var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loaded)?_c('div',{style:(_vm.infoStyle),domProps:{"innerHTML":_vm._s(_vm.info)}}):_c('div',[_c('pdf-viewer',{attrs:{"docsInstKey":_vm.docsInstKey,"fileUrl":_vm.formData.pdfDocFileUrl,"signAreaList":_vm.formData.signAreaList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }